import { DesignTokens, Row } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { DesignInfoItem } from "./DesignInfoItem";
import { DesignSize } from "./DesignSize";
import { isPrintDesignFileName } from "../../../helper/designHelper";
import { EfsMelcoModelsDesign } from "melco-shared-logic";

const { spacings } = DesignTokens;

const StyledRow = styled(Row)`
  width: 270px;
`;

const displayNumber = (number?: number) => {
  if (number == null) {
    return undefined;
  }

  return String(number);
};

type DesignInfosProps = {
  design: EfsMelcoModelsDesign;
};

export const DesignInfos: React.FC<DesignInfosProps> = ({ design }) => {
  const { t } = useTranslation();
  const isPrintFile = isPrintDesignFileName(design.file_name!);

  const translationPrefix = "libraries.designs.detail.form";
  const unitPx = "px";

  const { colors, color_changes, stitches, trims, width, height } = design;

  const embroideryDesignContent = (
    <>
      <DesignInfoItem
        label={t(`${translationPrefix}.label.size`)}
        value={<DesignSize design={design} />}
      />
      <DesignInfoItem
        label={t(`${translationPrefix}.label.trims`)}
        value={displayNumber(trims)}
      />
      <DesignInfoItem
        label={t(`${translationPrefix}.label.colors`)}
        value={displayNumber(colors)}
      />
      <DesignInfoItem
        label={t(`${translationPrefix}.label.color_changes`)}
        value={displayNumber(color_changes)}
      />
      <DesignInfoItem
        label={t(`${translationPrefix}.label.stitches`)}
        value={displayNumber(stitches)}
      />
    </>
  );

  const printDesignContent = (
    <>
      <DesignInfoItem
        label={t(`${translationPrefix}.label.width`)}
        value={`${displayNumber(width)} ${unitPx}`}
      />
      <DesignInfoItem
        label={t(`${translationPrefix}.label.height`)}
        value={`${displayNumber(height)} ${unitPx}`}
      />
    </>
  );

  return (
    <StyledRow gutter={[spacings.xlarge, 0]}>
      {isPrintFile ? printDesignContent : embroideryDesignContent}
    </StyledRow>
  );
};
